export default {
    title: 'AWS Infra',
    comingSoon: 'Coming Soon',
    welcome: (username:any) => `Hello ${username}`,
}
